import { arrayCreate2 } from '../../lib/util/jsTools';
import { BlockId } from './block';
import { config } from './config';
import { GoalId } from './goal';
import { MysteryItemRewardId } from './reward';

// reward definitions
//-----------------------------------------------------------------------------
export type RewardsDef = { [key in MysteryItemRewardId]?: RewardDef };

// goal definitions
//-----------------------------------------------------------------------------
export type GoalsDef = { [key in GoalId]?: number };

// grid definitions
//-----------------------------------------------------------------------------
//TODO: use string instead
export type BlockOption = number;

export type BlockDef = {
  id: BlockId;
  option?: BlockOption;
};

export type CellDef = {
  enabled: boolean;
  blocks?: BlockDef[];
};

export type GridDef = {
  columns: number;
  rows: number;
  cells: CellDef[][];
};

export type RewardDef = {
  limit: number;
  odds: number;
};

export const match2BlockGenAlgorithms = <const>[
  'random',
  'easy',
  'easy-v2-powerups',
  'easy-v3-group-spawns',
  'easy-v4-larger-chains',
  'easy-v5-large-chains-2',
  'easy-small-chains',
  'medium-small-chains',
  'hard',
  'hard-v2-corners',
  'hard-v3-radial',
  'hard-v4-columns',
  'hard-v5-all',
  'hard-v6-chains-on-top',
  'hard-v7-small-chains',
  'hard-v8-radial-weighted',
  'ensure-match',
  'rubberbanding',
];

export type BlockGenAlgorithmDef = (typeof match2BlockGenAlgorithms)[number];
export type BlockGenAlgorithm = Exclude<BlockGenAlgorithmDef, 'rubberbanding'>;

// map definitions
//-----------------------------------------------------------------------------
export type MapDef = {
  moves: number;
  goals: GoalsDef;
  spawns: BlockId[];
  grid: GridDef;
  blockGen?: BlockGenAlgorithmDef;
};

export type ExtendedMapDef = MapDef & {
  regionVersion: string;
  levelVersion: string;
  levelHash: string;
  regionHash: string;
};

// defaults
//-----------------------------------------------------------------------------
export const defaultMapDef: MapDef = {
  moves: 10,
  goals: {
    basicRed: 10,
  },
  spawns: ['basicRed'],
  grid: {
    columns: config.map.columns,
    rows: config.map.rows,
    cells: arrayCreate2<CellDef>(
      config.map.columns,
      config.map.rows,
      (column, row) => ({ enabled: true }),
    ),
  },
};
